import React from "react";
import { t } from "../i18n";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const OfflineConfirmModal: React.FC<Props> = ({ open, onClose, onConfirm, loading }) => {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.7)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#111827",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.06)",
          borderRadius: 16,
          padding: 24,
          width: "min(92vw, 380px)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ fontWeight: 700, fontSize: "1.1rem", margin: "0 0 10px", textAlign: "center" }}>
          {t("offlineConfirmModal.goOffline")}
        </h3>
        <p style={{ color: "#9ca3af", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: 20, textAlign: "center" }}>
          {t("offlineConfirmModal.peopleWonTBe")}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              flex: 1,
              padding: "12px 14px",
              borderRadius: 10,
              background: "rgba(255,255,255,0.06)",
              color: "#9ca3af",
              border: "1px solid rgba(255,255,255,0.08)",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: "0.92rem",
            }}
          >
            {loading ? "..." : t("offlineConfirmModal.goOffline2")}
          </button>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: "12px 14px",
              borderRadius: 10,
              background: "linear-gradient(135deg, #24C961, #16a34a)",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: "0.92rem",
            }}
          >
            {t("offlineConfirmModal.stayLive")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfflineConfirmModal;
